import { makeAutoObservable, runInAction } from 'mobx';
import { displayErrorMessage } from '../helpers/utils';
import AdminService from '../services/AdminService';
import { LocationDataType } from './types/location';
import { User } from './types/user';

export class AdminStore {
  adminService: InstanceType<typeof AdminService>;
  users: User[] = [];
  locationsList: LocationDataType[] = [];
  isLoading = false;
  status: string;

  constructor() {
    this.adminService = new AdminService();
    makeAutoObservable(this, {}, { autoBind: true });
  }

  fetchLocations = async () => {
    this.locationsList = [];
    try {
      const response = await this.adminService.fetchAllLocations();
      if (response && response.status === 200) {
        runInAction(() => {
          response.data.map((item: LocationDataType) => this.locationsList.push(item));
        });
      }
    } catch (error) {
      runInAction(() => {
        this.status = 'error';
      });
      displayErrorMessage(error);
    }
  };

  fetchUsers = async () => {
    runInAction(() => {
      this.isLoading = true;
    });
    try {
      // TODO: refactor admin service and change to typescript
      const response = (await this.adminService.fetchUsers(1, 30, true)) as unknown as {
        status: number;
        data: { pageContent: User[] };
      };
      if (response && response.status === 200) {
        runInAction(() => {
          this.users = response.data.pageContent;
        });
      }
    } catch (error) {
      runInAction(() => {
        this.status = 'error';
      });
      displayErrorMessage(error);
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  };
}
